<template>
  <LinkButton
    :tag="emitOnlyClick ? 'button' : 'nuxt-link'"
    :variant="active ? 'secondary' : undefined"
    :to="emitOnlyClick ? undefined : url"
    :aria-label="ariaLabel"
    class="pagination-link"
    @click="emitClick"
  >
    {{ page }}
  </LinkButton>
</template>

<script setup lang="ts">
import { LinkButton } from '@i22team/td-longtail-vue-components';

type PaginationLinkProps = {
  page: number;
  url?: string | number;
  active?: boolean;
  emitOnlyClick?: boolean;
  ariaLabelPrefix?: string;
  currentPageAriaLabel?: string;
};

const props = withDefaults(defineProps<PaginationLinkProps>(), {
  url: undefined,
  active: false,
  emitOnlyClick: false,
  ariaLabelPrefix: '',
  currentPageAriaLabel: '',
});

const emit = defineEmits<{ click: [url: string | number | undefined] }>();

const ariaLabel = computed(() => {
  if (props.active && props.currentPageAriaLabel) return props.currentPageAriaLabel;
  if (props.ariaLabelPrefix) return `${props.ariaLabelPrefix} ${props.page}`;
  return props.page.toString();
});

function emitClick() {
  emit('click', props.url ?? undefined);
}
</script>
